<template>
  <div>
    <h1 class="font-weight-light my-10 ml-5">Configuración</h1>
    <v-card>
      <v-row wrap>
        <v-col
          class="py-1 elevation-2"
          grow>
          <v-tabs
            v-model="tab"
            class="fill-width"
            grow
            height="60px"
            show-arrows>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              v-for="t in tabs"
              :key="t.name">
              <div class="caption py-1"> {{t.name}}</div>
            </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="tab"
            class="pa-4"
            grow>
            <v-tab-item>
              <div class="mt-10">
                <Categorias />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="mt-10">
                <Cursos />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="mt-10">
                <Lectivo />
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="mt-10">
                <Cuotas />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>


<script>
  import Categorias from "@/components/admin/components/CategoriaConfig.vue";
  import Cursos from "@/components/admin/components/CursosConfig.vue";
  import Lectivo from "@/components/admin/components/LectivoConfig.vue";
  import Cuotas from "@/components/admin/components/CuotasCrear.vue";

  export default {
    components: {
      Categorias,
      Cursos,
      Lectivo,
      Cuotas,
    },
    data () {
      return {

        tab: 0,
        tabs: [
          {name: 'Categorias', icon: 'mdi-email'},
          {name: 'Cursos Genéricos', icon: 'mdi-trash-can'},
          {name: 'Año Lectivo', icon: 'mdi-email-send'},
          {name: 'Cuotas', icon: 'mdi-email-edit-outline'}
        ],

      }
    },

  }
</script>

<style scoped>

</style>